import { render } from "./menuStep.vue?vue&type=template&id=2edbfd02&ts=true"
import script from "./menuStep.vue?vue&type=script&lang=ts"
export * from "./menuStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__